/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.ResponseMsg = (function() {

    /**
     * Properties of a ResponseMsg.
     * @exports IResponseMsg
     * @interface IResponseMsg
     * @property {string|null} [guid] ResponseMsg guid
     * @property {string|null} [refGuid] ResponseMsg refGuid
     * @property {number|null} [version] ResponseMsg version
     * @property {number|null} [code] ResponseMsg code
     * @property {string|null} [msg] ResponseMsg msg
     * @property {ResponseMsg.ResponseType|null} [responseType] ResponseMsg responseType
     * @property {Array.<string>|null} [data] ResponseMsg data
     * @property {number|Long|null} [GlobalUnread] ResponseMsg GlobalUnread
     */

    /**
     * Constructs a new ResponseMsg.
     * @exports ResponseMsg
     * @classdesc Represents a ResponseMsg.
     * @implements IResponseMsg
     * @constructor
     * @param {IResponseMsg=} [properties] Properties to set
     */
    function ResponseMsg(properties) {
        this.data = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ResponseMsg guid.
     * @member {string} guid
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.guid = "";

    /**
     * ResponseMsg refGuid.
     * @member {string} refGuid
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.refGuid = "";

    /**
     * ResponseMsg version.
     * @member {number} version
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.version = 0;

    /**
     * ResponseMsg code.
     * @member {number} code
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.code = 0;

    /**
     * ResponseMsg msg.
     * @member {string} msg
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.msg = "";

    /**
     * ResponseMsg responseType.
     * @member {ResponseMsg.ResponseType} responseType
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.responseType = 0;

    /**
     * ResponseMsg data.
     * @member {Array.<string>} data
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.data = $util.emptyArray;

    /**
     * ResponseMsg GlobalUnread.
     * @member {number|Long} GlobalUnread
     * @memberof ResponseMsg
     * @instance
     */
    ResponseMsg.prototype.GlobalUnread = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new ResponseMsg instance using the specified properties.
     * @function create
     * @memberof ResponseMsg
     * @static
     * @param {IResponseMsg=} [properties] Properties to set
     * @returns {ResponseMsg} ResponseMsg instance
     */
    ResponseMsg.create = function create(properties) {
        return new ResponseMsg(properties);
    };

    /**
     * Encodes the specified ResponseMsg message. Does not implicitly {@link ResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof ResponseMsg
     * @static
     * @param {IResponseMsg} message ResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.refGuid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.version);
        if (message.code != null && message.hasOwnProperty("code"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.code);
        if (message.msg != null && message.hasOwnProperty("msg"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.msg);
        if (message.responseType != null && message.hasOwnProperty("responseType"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.responseType);
        if (message.data != null && message.data.length)
            for (var i = 0; i < message.data.length; ++i)
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.data[i]);
        if (message.GlobalUnread != null && message.hasOwnProperty("GlobalUnread"))
            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.GlobalUnread);
        return writer;
    };

    /**
     * Encodes the specified ResponseMsg message, length delimited. Does not implicitly {@link ResponseMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ResponseMsg
     * @static
     * @param {IResponseMsg} message ResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResponseMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof ResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ResponseMsg} ResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResponseMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResponseMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.refGuid = reader.string();
                break;
            case 3:
                message.version = reader.int32();
                break;
            case 4:
                message.code = reader.int32();
                break;
            case 5:
                message.msg = reader.string();
                break;
            case 6:
                message.responseType = reader.int32();
                break;
            case 7:
                if (!(message.data && message.data.length))
                    message.data = [];
                message.data.push(reader.string());
                break;
            case 8:
                message.GlobalUnread = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ResponseMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ResponseMsg} ResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResponseMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ResponseMsg message.
     * @function verify
     * @memberof ResponseMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ResponseMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            if (!$util.isString(message.refGuid))
                return "refGuid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.code != null && message.hasOwnProperty("code"))
            if (!$util.isInteger(message.code))
                return "code: integer expected";
        if (message.msg != null && message.hasOwnProperty("msg"))
            if (!$util.isString(message.msg))
                return "msg: string expected";
        if (message.responseType != null && message.hasOwnProperty("responseType"))
            switch (message.responseType) {
            default:
                return "responseType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!Array.isArray(message.data))
                return "data: array expected";
            for (var i = 0; i < message.data.length; ++i)
                if (!$util.isString(message.data[i]))
                    return "data: string[] expected";
        }
        if (message.GlobalUnread != null && message.hasOwnProperty("GlobalUnread"))
            if (!$util.isInteger(message.GlobalUnread) && !(message.GlobalUnread && $util.isInteger(message.GlobalUnread.low) && $util.isInteger(message.GlobalUnread.high)))
                return "GlobalUnread: integer|Long expected";
        return null;
    };

    /**
     * Creates a ResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ResponseMsg} ResponseMsg
     */
    ResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.ResponseMsg)
            return object;
        var message = new $root.ResponseMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.refGuid != null)
            message.refGuid = String(object.refGuid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.code != null)
            message.code = object.code | 0;
        if (object.msg != null)
            message.msg = String(object.msg);
        switch (object.responseType) {
        case "UNKNOWN":
        case 0:
            message.responseType = 0;
            break;
        case "LOGIN":
        case 1:
            message.responseType = 1;
            break;
        case "GUID":
        case 2:
            message.responseType = 2;
            break;
        case "UNREAD":
        case 3:
            message.responseType = 3;
            break;
        case "CLEAR_UNREAD":
        case 4:
            message.responseType = 4;
            break;
        case "PULL_LASTMSG":
        case 5:
            message.responseType = 5;
            break;
        case "CALL_RESPONSE":
        case 6:
            message.responseType = 6;
            break;
        case "CALL_OPT_RESPONSE":
        case 7:
            message.responseType = 7;
            break;
        case "MSG_READ_STATUS":
        case 8:
            message.responseType = 8;
            break;
        case "SYNC_FRIENDS":
        case 9:
            message.responseType = 9;
            break;
        }
        if (object.data) {
            if (!Array.isArray(object.data))
                throw TypeError(".ResponseMsg.data: array expected");
            message.data = [];
            for (var i = 0; i < object.data.length; ++i)
                message.data[i] = String(object.data[i]);
        }
        if (object.GlobalUnread != null)
            if ($util.Long)
                (message.GlobalUnread = $util.Long.fromValue(object.GlobalUnread)).unsigned = false;
            else if (typeof object.GlobalUnread === "string")
                message.GlobalUnread = parseInt(object.GlobalUnread, 10);
            else if (typeof object.GlobalUnread === "number")
                message.GlobalUnread = object.GlobalUnread;
            else if (typeof object.GlobalUnread === "object")
                message.GlobalUnread = new $util.LongBits(object.GlobalUnread.low >>> 0, object.GlobalUnread.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a ResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ResponseMsg
     * @static
     * @param {ResponseMsg} message ResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (options.defaults) {
            object.guid = "";
            object.refGuid = "";
            object.version = 0;
            object.code = 0;
            object.msg = "";
            object.responseType = options.enums === String ? "UNKNOWN" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.GlobalUnread = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.GlobalUnread = options.longs === String ? "0" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            object.refGuid = message.refGuid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = message.code;
        if (message.msg != null && message.hasOwnProperty("msg"))
            object.msg = message.msg;
        if (message.responseType != null && message.hasOwnProperty("responseType"))
            object.responseType = options.enums === String ? $root.ResponseMsg.ResponseType[message.responseType] : message.responseType;
        if (message.data && message.data.length) {
            object.data = [];
            for (var j = 0; j < message.data.length; ++j)
                object.data[j] = message.data[j];
        }
        if (message.GlobalUnread != null && message.hasOwnProperty("GlobalUnread"))
            if (typeof message.GlobalUnread === "number")
                object.GlobalUnread = options.longs === String ? String(message.GlobalUnread) : message.GlobalUnread;
            else
                object.GlobalUnread = options.longs === String ? $util.Long.prototype.toString.call(message.GlobalUnread) : options.longs === Number ? new $util.LongBits(message.GlobalUnread.low >>> 0, message.GlobalUnread.high >>> 0).toNumber() : message.GlobalUnread;
        return object;
    };

    /**
     * Converts this ResponseMsg to JSON.
     * @function toJSON
     * @memberof ResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * ResponseType enum.
     * @name ResponseMsg.ResponseType
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} LOGIN=1 LOGIN value
     * @property {number} GUID=2 GUID value
     * @property {number} UNREAD=3 UNREAD value
     * @property {number} CLEAR_UNREAD=4 CLEAR_UNREAD value
     * @property {number} PULL_LASTMSG=5 PULL_LASTMSG value
     * @property {number} CALL_RESPONSE=6 CALL_RESPONSE value
     * @property {number} CALL_OPT_RESPONSE=7 CALL_OPT_RESPONSE value
     * @property {number} MSG_READ_STATUS=8 MSG_READ_STATUS value
     * @property {number} SYNC_FRIENDS=9 SYNC_FRIENDS value
     */
    ResponseMsg.ResponseType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "LOGIN"] = 1;
        values[valuesById[2] = "GUID"] = 2;
        values[valuesById[3] = "UNREAD"] = 3;
        values[valuesById[4] = "CLEAR_UNREAD"] = 4;
        values[valuesById[5] = "PULL_LASTMSG"] = 5;
        values[valuesById[6] = "CALL_RESPONSE"] = 6;
        values[valuesById[7] = "CALL_OPT_RESPONSE"] = 7;
        values[valuesById[8] = "MSG_READ_STATUS"] = 8;
        values[valuesById[9] = "SYNC_FRIENDS"] = 9;
        return values;
    })();

    return ResponseMsg;
})();

module.exports = $root;
